import React, {useRef, useEffect, useState, useMemo} from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import Seo from '../components/seo'
import { GatsbyImage } from "gatsby-plugin-image"
import ContentWithIndex from "../components/reusables/ContentWithIndex"
import Timeline from "../components/timeline/timeline"
import '../css/style.css'

// We're using Gutenberg so we need the block styles
// these are copied into this project due to a conflict in the postCSS
// version used by the Gatsby and @wordpress packages that causes build
// failures.
// @todo update this once @wordpress upgrades their postcss version

const DWOLLA_EXPERIENCE_ITEMS = [
  'java-script',
  'type-script',
  'next-js',
  'material-ui'
]

const HomeTemplate = (data) => {
  const skillListUL = useRef(null);

  const [projectsList, setProjectsList] = useState(null);
  const [mobileFiltersShowing, setMobileFiltersShowing] = useState(false);
  const [activeTimelineItem, setActiveTimelineItem] = useState(data?.data?.wpPage?.homeData?.careerTimeline?.careerItem[0]);
  const [timelineYear, setTimelineYear] = useState(data?.data?.wpPage?.homeData?.careerTimeline?.careerItem[0].timelineDateAnchor)

  useEffect(() => {  
    //animation logic
    /*
    * using the title for the filter on the projects.
      ex: 
      title = String | 'Java Script'

      to create the filter name, i will 
      - downcase the string 'J' and 'S' and then
      - Split the string in a space ' '
      - then join then on a '-'.
      - ex: Java Script => java-script

      to create the Title
      - Split the string on empty space ' '
      - Join both items with no space
      - ex: Java Script => JavaScript
    */
    if(!skillListUL) return;
    const parentUL = skillListUL.current;
    const sectionWrapper = parentUL.parentElement.parentElement;
    const skillz = parentUL.children;

    const removePrevActive = () => {
      const active = parentUL.querySelector('.active');
      if(active) active.classList.remove('active');
    }

    const addListener = (skillLI) => {
      const ctaCol = sectionWrapper.children[1];
      const dynamicCTA = ctaCol.children[0];
      const [titleEle, anchorEle] = dynamicCTA.children;
      
      const skillTitle = skillLI.dataset.skillTitle;
      
      const newTitle = skillTitle.split(' ').join('');
      const newFilter = skillTitle.toLowerCase().split(' ').join('-');
      
      /**
       * if newFilter is in new array, addExperienceListener()
       * 
       * else addProjectListener()
       */
      // console.log('newFIlter', newFilter)
      if(DWOLLA_EXPERIENCE_ITEMS.includes(newFilter)){
        skillLI.addEventListener('click', () =>{
          removePrevActive()
          titleEle.innerText = newTitle;
          anchorEle.href = '#timeline-section'
          anchorEle.setAttribute('data-filter', newFilter);
          anchorEle.innerText = `View ${newTitle} Experience`;
          skillLI.classList.add('active');
        })
      } else {
        skillLI.addEventListener('click', () =>{
          removePrevActive()
          titleEle.innerText = newTitle;
          anchorEle.href = '#portfolio'
          anchorEle.setAttribute('data-filter', newFilter);
          anchorEle.innerText = `View ${newTitle} Projects`;
          skillLI.classList.add('active');
        })
      }

    }

    for(const skill of skillz){
      addListener(skill);
    }
    
    if(!parentUL.querySelector('.active')){
      skillz[0].click();
    }
  }, [ skillListUL ]);

  
  const { 
    homeData
  } = data.data.wpPage;

  const {
    seoTitle, metaDescription
  } = data.data.wpPage.PAseo;

  
  // Banner Section
  const {
    ctaColumn, 
    textColumn: {
      bannerText,
      button: bannerButton
    }
  } = homeData.banner;

  const cta_items = ctaColumn && ctaColumn.map((ctaItem, i) => {
    const {target, title, url} = ctaItem.link;

    return(
      <a className="col x-center y-center" key={i} href={url} target={target} title={title}>{title}</a>
    )
  });

  // overlapping section
  const {
    textColumn: {
      sectionTitle: overlappingTitle,
      skillsShortList
    }
  } = homeData.overlappingSection;

  const topSkills = skillsShortList.map((skill, i) => {
    if("complexItem" in skill){
      // complex item test
      // console.log('Complex skill', skill)
      return null;
    } else if('simpleItem' in skill){
      // simple item text;
      const {altText, localFile, title} = skill.simpleItem;
      /*
      * using the title for the filter on the projects.
        ex: 
        title = String | 'Java Script'

        to create the filter name, i will 
        - downcase the string 'J' and 'S' and then
        - Split the string in a space ' '
        - then join then on a '-'.
        - ex: Java Script => java-script

        to create the Title
        - Split the string on empty space ' '
        - Join both items with no space
        - ex: Java Script => JavaScript
      */
      return (
        <li key={i} data-skill-title={title}>
          <GatsbyImage className="pa-skill_logo" image={localFile.childImageSharp.gatsbyImageData} alt={altText}/>
        </li>
      );
    } else{
      return null;
    }
  });

  // About Section
  const { 
    leftCol: aboutMeText, 
    rightCol: aboutMeRightCol 
  } = homeData.aboutSection;

  // const aboutLinks = aboutMeRightCol.links.map((link, i) => {
  //   if('link' in link){
  //     const { target, title, url } = link.link;

  //     return (
  //       <li className="link-list-item" key={i}>
  //         <a target={target} title={title} href={url}>{title}</a>
  //       </li>
  //     )
  //   }
  // });


  // Masonry Section & timeline
  const { dynamicMasonry, careerTimeline } = homeData
  
  
  const filters = {};

  /**
   * filters = {
   *  filter-slug: {
   *      name,
   *      slug,
   *      items: {projectItem}
   *    }
   * }
   */

  const addItem = (slug, projectItem) => {
    filters[slug]['items'].push(projectItem);
  }


  const createItem = (slug, name, projectItem) => {
    filters[slug] = {
      name,
      slug,
      items: [projectItem]
    }
  }

  const createMasonryItem = ({id, title, featuredImage, uri}, i) => {
    return (
      <div className="masonry_item grid-item" data-item-number={i + 1} key={id} data-item-id={id}>
        <Link to={uri}></Link>
        <div className="masontry_item-wrapper">
          <h3>{title}</h3>
        </div>
        {/*  These must ALLLLL be SVGs or PNGs. Choosing PNGs to get blurr effect */}
        {featuredImage && featuredImage.node.localFile.childImageSharp&&(
          <div className="images-wrapper col y-center x-center">
            <GatsbyImage className="pa-project_logo sharp" image={featuredImage.node.localFile.childImageSharp.sharp} alt="background-image"/>
          </div>
        )}
      </div>
    )
  }
  
  const skillFullList = dynamicMasonry.map((project, i) => {
    const { title, id, featuredImage, terms, uri } = project;
    
    const returnItem = createMasonryItem(project, i);

    const itemData = {i, id, title, featuredImage, uri};

    if(terms && terms.nodes.length > 0){

      for(const term of terms.nodes){
  
        const {slug, name} = term;

        filters[slug]?addItem(slug, itemData):createItem(slug, name, itemData);
      }
    }

    filters['all']?addItem('all', itemData):createItem('all', 'All', itemData);

    return returnItem;
  });


  if(!projectsList) setProjectsList(skillFullList);

  const fadeOut = DOMEle => {
    return DOMEle.classList.add('fade-out')
  }

  const fadeIn = DOMEle => {
    return DOMEle.classList.remove('fade-out')
  }

  const selectFilterItem = (slug, sectionContainer) => {
    const currentActive = sectionContainer.querySelector('li.active');
    currentActive.classList.remove('active');
    
    const newActive = sectionContainer.querySelector(`li[data-filter-key=${slug}]`);

    if(newActive) newActive.classList.add('active');
  }

  const handleFilterClick = (e, slug, items) => {
    const count = items.length;
    const sectionContainer = e.currentTarget.parentElement.parentElement.parentElement;
    const gridCol = sectionContainer.children[1];
    fadeOut(gridCol);

    selectFilterItem(slug, sectionContainer);

    if(mobileFiltersShowing) handleMobileFilterShow();
    
    setTimeout(() => {
      gridCol.setAttribute('data-grid-items', count);
      const newItems = items.map((item, i) =>{
        // const {id, title, featuredImage} = item
      
        return createMasonryItem(item, i);
      });

      setProjectsList(newItems);
      
      fadeIn(gridCol);
    }, 300);
  }

  const handleMobileFilterShow = () =>{
    // make body overflow hidden to prevent scroll
    // make h3 event listener close pop up filters
    const windowW = typeof window !== "undefined"?window.innerWidth:0;

    if(windowW > 767) return;
    
    const parent = document.getElementById('portfolio');
    
    if(!mobileFiltersShowing){
      parent.classList.add('show-filters');
      
      setTimeout(() => {
        setMobileFiltersShowing(true)
        document.body.style.overflow = 'hidden';
      }, 400);
    } else {
      parent.classList.remove('show-filters');

      setTimeout(() => {
        setMobileFiltersShowing(false)
        document.body.style.overflow = '';
      }, 400);
    }
  }

  const MemoedTimeline = useMemo(() => (
    <Timeline 
      dataset={careerTimeline?.careerItem} 
      active={activeTimelineItem} 
      setActive={setActiveTimelineItem} 
      setTimelineYear={setTimelineYear}
    />
  ), [careerTimeline?.careerItem, activeTimelineItem]);

  return(
    <Layout>
      <Seo title={seoTitle} description={metaDescription} />
      <section className="home-banner col">
        <div className="container row">
          <div className="l-col">
            <div className="wrapper">

              <div dangerouslySetInnerHTML={{__html: bannerText}}></div>

              <a href={bannerButton.url} target={bannerButton.target} title={bannerButton.title}>
                {bannerButton.title}
              </a>

            </div>
          </div>
          <div className="r-col">

            <div className="hex-cta row">{cta_items}</div>

          </div>
        </div>
      </section>
      <section className="overlapping-section row" id="top-skills">
        <div className="container row end">
          <div className="text-col">
            <h2 className="border-b white">{overlappingTitle}</h2>
            <ul className="row wrap y-center" ref={skillListUL} >
              {topSkills}
            </ul>
          </div>
          <div className="cta-col col">
            <div className="dynamic-cta col">
              <h2>JavaScript</h2>
              <a 
                href="#portfolio" 
                className="boxed-btn white"
                data-filter="java-script"
                onClick={(e) => {
                  const anchorFilt = e.currentTarget.dataset?.filter;
                  
                  if(!anchorFilt) return;
                  /**
                   * if filter is in new array, selectExperience()
                   * 
                   * else selectProject()
                   */
                  if(DWOLLA_EXPERIENCE_ITEMS.includes(anchorFilt)){
                    const careerItems = data?.data?.wpPage?.homeData?.careerTimeline?.careerItem;
                    const selectedItem = careerItems.find(item => item.companyName.toLowerCase().includes('dwolla'));
                    setActiveTimelineItem(selectedItem);
                  } else {
                    const projectFilter = document.querySelector(`li[data-filter-key='${anchorFilt}']`);
                    
                    if(projectFilter) setTimeout(() => projectFilter.click(), 500);
                  }                  
                }}
              >View JavaScript Projects</a>
            </div>
            <div className="static-cta col">
            </div>
          </div>
        </div>
        <div className="bg-ele"></div>
      </section>
      <section className="about-section" id="about-section">
        <div className="container row">
          <div className="l-col" dangerouslySetInnerHTML={{__html: aboutMeText}}></div>
          <div className="r-col">
            <GatsbyImage image={aboutMeRightCol.image.localFile.childImageSharp.gatsbyImageData} alt="Pavel Portrait Image"/>
            <ul className="links"></ul>
          </div>
        </div>
      </section>
      <section className="timeline-section" id="timeline-section">
        <div className="container col">
          <div className="timeline-wrapper col">
            <h2>{careerTimeline?.title} | {new Date(timelineYear).getFullYear()}</h2>
            <div className="memoed-timeline">
              {MemoedTimeline}
            </div>
            <div>
              <h3>{activeTimelineItem?.companyName}</h3>
              <p className="date"><i>{activeTimelineItem?.displayDate}</i></p>
              <p className="position">{activeTimelineItem?.position}</p>
              <div className="timeline-skills">
                {activeTimelineItem?.skills?.map((skill, i) => {
                  const imageAltText = skill?.skill?.altText || "";
                  const image = skill?.skill?.localFile?.childImageSharp?.gatsbyImageData
                  return (
                    <GatsbyImage 
                      key={imageAltText + i}
                      image={image} 
                      alt={imageAltText}
                      title={imageAltText}
                      imgStyle={{
                        objectFit: 'contain'
                      }}
                    />
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
      <ContentWithIndex
        toc={Object.keys(filters).sort().map((filterKey, i) => {
          const {items, name, slug} = filters[filterKey];
          
          return (
            <li 
            key={slug} 
            data-filter-key={slug} 
            onClick={(e) => handleFilterClick(e, slug, items)}
            className={slug==="all"?'active':''}
            >{name}</li>
          )
        })}
        content={(
          <div className="pa-collage_grid">
            {projectsList}
          </div>
        )}
        sectionTitle={'Portfolio'}
        tocTitle={'Filters'}
        handleMobileTocShow={handleMobileFilterShow}
        sectionId={'portfolio'}
      />
    </Layout>
  )

}

export default HomeTemplate

export const pageQuery = graphql`
  query WpPosts {
    wpPage(id: {eq: "cG9zdDoyMg=="}) {
      title
      PAseo {
        seoTitle
        metaDescription
      }
      homeData {

        # Banner section
        banner {
          textColumn {
            button {
              target
              title
              url
            }
            bannerText
          }
          ctaColumn {
            link {
              target
              title
              url
            }
          }
        }

        # Overlapping Section
        overlappingSection {
          textColumn {
            sectionTitle
            skillsShortList {
              ... on WpPage_Homedata_OverlappingSection_TextColumn_SkillsShortList_SkillItem {
                simpleItem {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
                    }
                  }
                  altText
                  title
                }
              }
            }
          }
          auxCta {
            title
            localFile {
              url
            }
          }
        }

        # About Section
        aboutSection {
          leftCol
          rightCol {
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
                }
              }
            }
            links {
              link {
                target
                title
                url
              }
            }
          }
        }

        # Timeline 
        careerTimeline {
          title
          careerItem {
            companyName
            displayDate
            hasProjects
            hexColor
            position
            timelineDateAnchor
            skills {
              skill {
                altText
                localFile {
                  childImageSharp {
                    gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
                  }
                }
              }
            }
          }
        }

        #dynanic masonry
        dynamicMasonry {
          ... on WpPortfolioItem {
            title
            id
            uri
            featuredImage {
              node {
                localFile {
                  childImageSharp {
                    blurred: gatsbyImageData(layout: CONSTRAINED, quality:1)
                    sharp: gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
                  }
                }
              }
            }
            terms {
              nodes {
                slug
                name
              }
            }
          }
        }
      }
    }
  }
`
